import Vue from 'vue'
import App from './App.vue'
import store from './store'
import './scss/style.scss';
import productJson from "./assets/data.json";
import configJson from "./assets/config.json";
import { utils } from '@/utils';

Vue.config.productionTip = false

const productData = productJson;
const variantCombinations = utils.createVariantCombinations(productJson.products)
new Vue({
  store,
  render: h => h(App),
  created() {
    this.$store.commit("productData", productData.products);
    this.$store.commit("variantCombinations", variantCombinations);
    this.$store.commit("config", configJson);
  }
}).$mount('#app')
